import { call, put, takeEvery, takeLeading } from "redux-saga/effects";
import { types } from "../action-types";
import { createBidApi, createmultiBidApi } from "../../API/API";
import { alertNotification } from "../../components/TopNotification/alertNotification";

const getBidErrorMessage = (error) =>
  error?.response?.data?.errorMessage ||
  error?.response?.data?.message ||
  error?.message ||
  "Something went wrong";

const hasAlreadyPlacedBids = (data) => {
  return Array.isArray(data?.data?.alreadyAcceptedBids) && data.data.alreadyAcceptedBids.length > 0;
};

function* CreateBidSaga(params) {
  try {
    const response = yield call(createBidApi, params);
    if (response) {
        yield put({
          type: types.CREATE_BID_SUCCESS,
          payload: response.data,
          responseData: response.data,
        });
        if(response.status === 200){
          const bids = {payload:{bids:[params.payload]}};
          yield put({type: types.Remove_Bidded_skillListings, payload:bids});
          if (typeof params?.onSuccess === "function") {
            yield call(params.onSuccess, response.data);
          }
        }
    }
  } catch (error) {
    const errorData = error?.response?.data;
    yield put({
      type: types.CREATE_BID_FAILURE,
      error,
      payload: getBidErrorMessage(error),
      errorData,
    });
    if (typeof params?.onFailure === "function") {
      yield call(params.onFailure, errorData || error);
    }
  }
}

export function* watchCreateBidSaga() {
  //added the take leading in watch create bid saga
  yield takeLeading(types.CREATE_BID_REQUESTED, CreateBidSaga);
}

// welfkel

function* createmultiBidSaga(params) {
  try {
    const response = yield call(createmultiBidApi, params);

    // API Backend
    yield put({
      type: types.CREATE_MULTI_BID_SUCCESS,
      payload: response?.data?.data || response?.data?.createdBids,
      responseData: response?.data,
    });
    if(response.status === 200){
      yield put({type: types.Remove_Bidded_skillListings, payload:params})
      if (!hasAlreadyPlacedBids(response?.data)) {
        alertNotification("success", "Bids placed successfully");
      }
      if (typeof params?.onSuccess === "function") {
        yield call(params.onSuccess, response?.data);
      }
    }
  } catch (error) {
    const errorMessage = getBidErrorMessage(error);
    yield put({
      type: types.CREATE_MULTI_BID_FAILURE,
      error,
      payload: errorMessage,
      errorData: error?.response?.data,
    });
    alertNotification("error", errorMessage);
  }
}

export function* watchCreatemultiBidSaga() {
  yield takeEvery(types.CREATE_MULTI_BID_REQUESTED, createmultiBidSaga);
}
